export function Vacuum(): JSX.Element {
  return (
    <svg
      width="274"
      height="90"
      viewBox="0 0 274 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M198.836 87.4873V88.9718H270.363C272.21 88.9718 273.71 87.4725 273.71 85.6251V3.64166C273.71 1.79417 272.21 0.294922 270.363 0.294922H198.836V1.77941H189.433V0.294922H3.4942C1.64671 0.294922 0.147461 1.79417 0.147461 3.64166V85.628C0.147461 87.4755 1.64671 88.9747 3.4942 88.9747H189.433V87.4903H198.836V87.4873Z"
        fill="#E9E9E9"
      />
      <path
        d="M121.339 81.2449C122.072 81.2449 122.667 80.0086 122.667 78.4851V10.879C122.667 9.35547 122.072 8.11914 121.339 8.11914H115.59L114.41 8.70888H112.051L110.872 8.11914C110.872 8.11914 35.5781 8.11914 25.4486 8.11914C24.5537 8.11914 24.2457 8.70888 23.5897 8.70888C21.2307 8.70888 21.4773 8.11914 21.2307 8.11914C18.9855 8.11914 15.4814 8.11914 15.4814 8.11914C14.7486 8.11914 14.1539 9.35547 14.1539 10.879C14.1539 10.879 14.7435 15.7858 14.7435 16.9653C14.7435 18.1448 14.1551 18.8043 14.1538 19.914C14.1409 30.9175 14.1033 70.11 14.2718 70.632C14.4954 71.3251 14.7436 70.632 14.7436 72.4012C14.7437 74.1704 14.1539 74.1704 14.1539 74.1704V78.4875C14.1539 80.011 14.7436 80.6576 15.4814 81.2473H89.2371L121.339 81.2449Z"
        fill="white"
      />
      <path
        d="M258.607 1.7793H152.822C148.548 1.7793 145.084 5.24382 145.084 9.51753V79.7489C145.084 84.0227 148.548 87.4872 152.822 87.4872H258.607C262.881 87.4872 266.346 84.0227 266.346 79.7489V9.51753C266.346 5.24382 262.881 1.7793 258.607 1.7793Z"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M258.608 3.45215H152.822C149.473 3.45215 146.757 6.16748 146.757 9.51701V79.7484C146.757 83.098 149.473 85.8133 152.822 85.8133H258.608C261.957 85.8133 264.672 83.098 264.672 79.7484V9.51701C264.672 6.16748 261.957 3.45215 258.608 3.45215Z"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.9632 83.5354V87.4872H15.6823C11.4089 87.4872 7.94409 84.0224 7.94409 79.7489V9.51753C7.94409 5.24409 11.4089 1.7793 15.6823 1.7793H59.9603V5.734L57.4517 8.24258H25.817C25.2503 8.24258 24.6926 8.38719 24.1967 8.66166H22.1043C21.6085 8.38719 21.0507 8.24258 20.484 8.24258H16.0394C15.1157 8.24258 14.3661 8.99221 14.3661 9.91595V14.3606C14.3661 14.9272 14.5107 15.485 14.7851 15.9808V18.0733C14.5107 18.5691 14.3661 19.1269 14.3661 19.6935V69.5759C14.3661 70.1425 14.5107 70.7003 14.7851 71.1962V73.2886C14.5107 73.7844 14.3661 74.3422 14.3661 74.9089V79.3535C14.3661 80.2772 15.1157 81.0268 16.0394 81.0268H57.4487L59.9573 83.5354"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.6943 87.4872H258.608C262.881 87.4872 266.346 84.0224 266.346 79.7489V9.51753C266.346 5.24409 262.881 1.7793 258.608 1.7793H76.6943V5.734L79.2029 8.24258H110.838C111.404 8.24258 111.962 8.38719 112.458 8.66166H114.55C115.046 8.38719 115.604 8.24258 116.171 8.24258H120.615C121.539 8.24258 122.289 8.99221 122.289 9.91595V79.3535C122.289 80.2772 121.539 81.0268 120.615 81.0268H79.2059L76.6973 83.5354V87.4872"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.9641 83.5368H15.9813C13.6704 83.5368 11.7993 81.6657 11.7993 79.3578V9.91435C11.7993 7.60646 13.6734 5.73535 15.9813 5.73535H59.9641"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.6943 83.5368H120.615C122.926 83.5368 124.797 81.6657 124.797 79.3578V9.91435C124.797 7.60646 122.923 5.73535 120.615 5.73535H76.6943"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.021 48.4008C205.1 48.4008 206.787 46.7148 206.787 44.635C206.787 42.5552 205.1 40.8691 203.021 40.8691C200.941 40.8691 199.255 42.5552 199.255 44.635C199.255 46.7148 200.941 48.4008 203.021 48.4008Z"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M203.02 46.6179C204.115 46.6179 205.003 45.7299 205.003 44.6346C205.003 43.5393 204.115 42.6514 203.02 42.6514C201.925 42.6514 201.037 43.5393 201.037 44.6346C201.037 45.7299 201.925 46.6179 203.02 46.6179Z"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.433 1.77941V0.294922H3.4942C1.64671 0.294922 0.147461 1.79417 0.147461 3.64166V85.628C0.147461 87.4755 1.64671 88.9748 3.4942 88.9748H189.433V87.4903"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M198.837 87.4873V88.9718H270.364C272.211 88.9718 273.711 87.4726 273.711 85.6251V3.64166C273.711 1.79417 272.211 0.294922 270.364 0.294922H198.837V1.77941"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.147461 41.0371H4.35007C6.33628 41.0371 7.94767 42.6485 7.94767 44.6347C7.94767 46.6209 6.33628 48.2323 4.35007 48.2323H0.147461"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.32898 46.6208C5.42593 46.6208 6.31519 45.7316 6.31519 44.6346C6.31519 43.5377 5.42593 42.6484 4.32898 42.6484C3.23203 42.6484 2.34277 43.5377 2.34277 44.6346C2.34277 45.7316 3.23203 46.6208 4.32898 46.6208Z"
        stroke="#16212D"
        strokeWidth="0.589744"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
